

















import Vue from "vue";
import router from "@/router";
import EnterOtp from "./EnterOTP.vue";
import EnterPhoneNumber from "./EnterPhoneNumber.vue";
import NoPhoneNumber from "./NoPhoneNumber.vue";
import {ResetTOTPStep} from "@/constant/enum";

export default Vue.extend({
  name: "ResetTOPT",
  components: {
    EnterOtp,
    EnterPhoneNumber,
    NoPhoneNumber
  },
  data() {
    const self = this;
    return {
      self,
      step: ResetTOTPStep,
      selectedStep: ResetTOTPStep.EnterPhoneNumber,
      phoneValid: false,
      phoneNumber: '',
    };
  },
  methods: {
    nextStep() {
      this.selectedStep = this.selectedStep + 1;
    },
    goBack() {
      router.push("/login");
    },
    backToLogin() {
      router.push("/login");
    }
  },
});
